/* app/js/src/components/channel/channel-wizard/channel-wizard.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
section {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.availability-zone-field {
  margin-top: 10px;
  margin-bottom: 20px;
}
.root-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.root-container .mam {
  max-width: 450px;
  width: 30vw;
}
.root-container .wizard {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.root-container .wizard .mt20 {
  margin-top: 30px;
}
.root-container .wizard header div {
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
  letter-spacing: -0.1px;
  height: 54px;
  padding: 27px;
}
.root-container .wizard main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.root-container .wizard main .summary {
  max-width: 40%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
/*# sourceMappingURL=channel-wizard.component.css.map */
